import { digitsOnly } from "./buildWhatsAppMeUrl";

const MIN_DIGITS = 8;
const MAX_DIGITS = 15;

/**
 * Build official WhatsApp “send” URL (web) from an E.164-ish value.
 * Example: https://api.whatsapp.com/send/?phone=%2B15550846547&text=&type=phone_number&app_absent=0
 *
 * @param {string | null | undefined} e164
 * @returns {string | null}
 */
export function buildWhatsAppApiSendUrlFromE164(e164) {
  const digits = digitsOnly(e164);
  if (digits.length < MIN_DIGITS || digits.length > MAX_DIGITS) {
    return null;
  }
  const url = new URL("https://api.whatsapp.com/send/");
  url.searchParams.set("phone", `+${digits}`);
  url.searchParams.set("text", "");
  url.searchParams.set("type", "phone_number");
  url.searchParams.set("app_absent", "0");
  return url.toString();
}
